import React, { useState } from "react";

import { Typography, Grid, Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import { useTheme } from "@mui/material/styles";

import { UserDetailsDTO, OrganizationDTO } from "@beable/roster-backend-client-v1";
import { UserListItem } from "@beable/roster-backend-client-v1";

import dataViewService from "../../services/DataViewService";
import { getStyles } from "./styles";
import UserDetails from "./UserDetails";
import UsersTable from "./UsersTable";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

interface UsersModalProps {
  open: boolean;
  teachers: UserListItem[];
  students: UserListItem[];
  admins: UserListItem[];
  handleClose: any;
  siteId?: number;
}

export default function UsersModal(props: UsersModalProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [modalStyle] = useState(getModalStyle);
  const [isUserDetailsLoading, setIsUserDetailsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState<UserDetailsDTO | undefined>(
    undefined
  );
  const [userDetailsTopOffset, setUserDetailsTopOffset] = useState(0);
  const [userOrgs, setUserOrgs] = useState<OrganizationDTO[]>([]);

  const handleUserClick = async (userId: string, event: any, role?: string) => {
    event.persist();
    setIsUserDetailsLoading(true);

    const fetchedUserDetails = await dataViewService.getUserDetails(userId);

    if (userOrgs.length > 0) {
      setUserOrgs([]);
    }

    if (fetchedUserDetails) {
      const topOffset = Number(event.target.offsetTop);
      setUserDetailsTopOffset(topOffset);
      setUserDetails(fetchedUserDetails);
    } else {
      setUserDetails(undefined);
      alert("Could not get the user details...");
    }

    if (role === "administrator" && props.siteId) {
      const data = await dataViewService.findUserOrgs(props.siteId, userId);
      if (data?.orgsMap && Object.keys(data.orgsMap).length > 0) {
        const academicYearId = Object.keys(data.orgsMap)[0];
        setUserOrgs(data.orgsMap[academicYearId] || []);
      }
    }

    setIsUserDetailsLoading(false);
  };

  const handleClose = () => {
    setUserDetails(undefined);
    props.handleClose();
  };

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={props.open}
      onClose={handleClose}
    >
      <Box sx={{ ...modalStyle, ...styles.paper }}>
        <Grid container>
          <Grid
            size={{
              xs: 12,
              sm: 12,
              md: 5,
              lg: 5,
              xl: 5
            }}>
            <Typography variant="h4">Users</Typography>
            <UsersTable
              teachers={props.teachers}
              students={props.students}
              admins={props.admins}
              onUserClick={handleUserClick}
            ></UsersTable>
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 12,
              md: 2,
              lg: 2,
              xl: 2
            }}></Grid>
          <Grid
            size={{
              xs: 12,
              sm: 12,
              md: 5,
              lg: 5,
              xl: 5
            }}>
            <UserDetails
              userDetails={userDetails}
              orgs={userOrgs}
              isLoading={isUserDetailsLoading}
              topOffset={userDetailsTopOffset}
            ></UserDetails>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
